function Footer() {
  return (
    <div className= "Footer">
      <h5>© Jason Quizhpi 2021  </h5>
      <div className= "icon">
      <div  className="icon"><a href ="https://www.linkedin.com/in/jason-quizhpi-30a41b169/"><img className="avatar"src=" https://res.cloudinary.com/briandanger/image/upload/v1568954107/linkedin_vnvo6s.png" alt="LinkedIn"></img></a></div>
        <div  className="icon"><a href="https://github.com/jquizhpi96"><img className="avatar"src=" https://res.cloudinary.com/briandanger/image/upload/v1568954107/github_fpykxh.png" alt="Github"></img></a></div>
        </div> 
    </div>
  )
}

export default Footer